/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IIntegration } from 'types';
import { Integration } from './types';

const initialState: IIntegration | null = null;

export const integrationReducer: Reducer<IIntegration | null> = (state = initialState, action) => {
  switch (action.type) {
    case Integration.GET_INTEGRATION_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    // Cleared while loading and on failure, so a previous location (possibly another site's) is never read as this one's.
    case Integration.GET_INTEGRATION_LOCATION_REQUEST:
    case Integration.GET_INTEGRATION_LOCATION_FAIL: {
      return {
        ...state,
        location: undefined,
      };
    }
    case Integration.GET_INTEGRATION_LOCATION_SUCCESS: {
      return {
        ...state,
        location: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
